var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDropdownContentBlockIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 48,
    viewBox: "0 0 49 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.5 6H10.5C8.294 6 6.5 7.794 6.5 10V38C6.5 40.206 8.294 42 10.5 42H38.5C40.706 42 42.5 40.206 42.5 38V10C42.5 7.794 40.706 6 38.5 6ZM23.086 29.414L15.086 21.414C14.306 20.634 14.306 19.366 15.086 18.586C15.866 17.806 17.134 17.806 17.914 18.586L24.5 25.172L31.086 18.586C31.866 17.806 33.134 17.806 33.914 18.586C34.694 19.366 34.694 20.634 33.914 21.414L25.914 29.414C25.134 30.196 23.866 30.196 23.086 29.414Z",
    fill: "#467077"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDropdownContentBlockIcon);
export default __webpack_public_path__ + "static/media/dropdown-content-block-icon.c88ec4c54c79064ab08ca328af2cfd45.svg";
export { ForwardRef as ReactComponent };